/* eslint-disable max-lines-per-function */
import { Field } from "formik";
import React from "react";
import { Grid } from "@mui/material";
import { US_PHONE_MASK } from "utils/phone";
import { Button } from "components/haven-design";
import {
  InputWithErrorLabel,
  MaskedInputWithErrorLabel,
} from "components/haven-design/form/inputs";
import { MaterialFormikSelect as SelectWithErrorLabel, MaterialFormikSelectAutocomplete } from "components/haven-design/form/select";
import { extendedStatesList } from "components/haven-design/state-picker";
import { Column } from "components/common/html";
import { YesNoRadio } from "components/haven-design/form/checkbox";
import { FormProps } from "../types";

const phoneTypeOptions = [
  { value: "", label: "Select" },
  { value: "mobile", label: "Mobile" },
  { value: "landline", label: "Landline" },
  { value: "work", label: "Work" },
];

const ContactForm: React.FC<FormProps> = () => {
  const [has2ndPhone, set2ndPhone] = React.useState(false);
  return (
    <div>
      <h3 className="margin-bottom-m">Please update any information that has changed</h3>

      <div style={{ maxWidth: 430 }}>
        <InputWithErrorLabel label="Mailing address" name="address1" type="text" />

        <InputWithErrorLabel label="Apartment/Suite (optional)" name="address2" type="text" />

        <InputWithErrorLabel label="City" name="city" type="text" />

        <Grid container spacing={2}>
          <Column width={6}>
            <MaterialFormikSelectAutocomplete
              id="state"
              name="state"
              placeholder="State"
              title="State"
              margin="dense"
              options={extendedStatesList}
            />
          </Column>
          <Column width={6}>
            <InputWithErrorLabel label="Zip Code" name="zip" type="text" />
          </Column>
        </Grid>

        <hr />

        <InputWithErrorLabel label="Email address" name="email" type="text" />

        <Grid container spacing={2}>
          <Column width={6}>
            <MaskedInputWithErrorLabel
              label="Primary phone number"
              name="primaryPhone"
              guide={false}
              mask={US_PHONE_MASK}
            />
          </Column>

          <Column width={6}>
            <SelectWithErrorLabel color="primary" margin="dense" name="primaryPhoneType" title="Type" style={{ lineHeight: "46px" }}
              options={phoneTypeOptions}
            />
          </Column>

          {!has2ndPhone && (
            <Column width={12}>
              <Button color="secondary" size="S" onClick={() => set2ndPhone(true)}>
                Add secondary phone
              </Button>
            </Column>
          )}
        </Grid>

        {has2ndPhone && (
          <Grid container spacing={2}>
            <Column width={6}>
              <MaskedInputWithErrorLabel
                label="Secondary phone number"
                name="secondaryPhone"
                type="text"
                guide={false}
                mask={US_PHONE_MASK}
              />
            </Column>
            <Column width={6}>
              <SelectWithErrorLabel color="primary" margin="dense" name="secondaryPhoneType" title="Type" options={phoneTypeOptions} />
            </Column>
          </Grid>
        )}

        <hr />

        <SelectWithErrorLabel
          color="primary"
          margin="dense"
          name="contactRelation"
          title="Optional Contact"
          options={[
            { value: "", label: "Select" },
            { value: "Friend", label: "Friend" },
            { value: "Family Member", label: "Family Member" },
            { value: "Case Manager or Housing Counselor", label: "Case Manager or Housing Counselor" },
            { value: "Other", label: "Other" },
          ]}
        />

        <Field name="contactRelation">
          {({ form }: { form: any }) => (
            <>
              {form.values.contactRelation && (
                <>
                  <InputWithErrorLabel
                    label="Name of Additional Contact Person"
                    name="contactName"
                    type="text"
                  />

                  <InputWithErrorLabel label="Contact Email" name="contactEmail" type="text" />

                  <Grid container spacing={2}>
                    <Column width={6}>
                      <MaskedInputWithErrorLabel
                        label="Primary phone number"
                        name="contactPhone"
                        mask={US_PHONE_MASK}
                        guide={false}
                      />
                    </Column>

                    <Column width={6}>
                      <SelectWithErrorLabel color="primary" margin="dense" name="contactPhoneType" title="Type"
                        options={phoneTypeOptions} />
                    </Column>
                  </Grid>
                </>
              )}
            </>
          )}
        </Field>
        <hr />
        <YesNoRadio label="Do you have a Section 8 voucher?"
          name="householdHasHousingAuthorityVoucher"
        />
      </div>
    </div>
  );
};

export default ContactForm;
